import * as angular from "angular";
import {IController} from "angular";

export class serviceStatusSelectCtrl implements IController {

  status: any;
  options: any;
  onChange: Function;

  /* @ngInject */
  constructor(private deliveriesConstants) {
  }

  $onInit() {
    if (!this.options) {
      this.options = this.deliveriesConstants.statuses;
    }
  }

  onClear() {
    this.onChange();
  };

}

angular
  .module('bringoz.admin.deliveries')
  .component('serviceStatusSelect', {
    bindings: {
      status: '<',
      options: '<?',
      onChange: '&'
    },
    template: require('./service-status-select.html').default,
    controller: serviceStatusSelectCtrl
  });

